import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Spinner } from "reactstrap";
import Card from "./Card";
import { useTranslations } from 'next-intl'
import { APIClient } from '../helpers/api_helper'

const BestOffersComponent = ({ category, type, favoriteIconRef, selectedLang }: { category: number, type: number, favoriteIconRef: any, selectedLang: string }) => {
    const t = useTranslations('')

    const api = useMemo(() => new APIClient(), []);
    const headers = useMemo(() => ({ "Accept-Language": selectedLang }), [
        selectedLang,
    ]);

    const [bestOffer, setBestOffer] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);

    const fetchBestOffers = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await api.get("/site/best/offers/", {}, headers);
            setBestOffer(response);
        } catch (error) {
            console.error("Failed to fetch best offers:", error);
        } finally {
            setIsLoading(false);
        }
    }, [api, headers]);

    useEffect(() => {
        fetchBestOffers();
    }, [fetchBestOffers]);

    return (
        <div className="home_best_offers">
            {isLoading ? (
                <Spinner className="me-2 text-center"> {t("Loading") + "..."} </Spinner>
            ) : (
                bestOffer?.[type]?.[category]?.map((item: any, index: number) => (
                    <Card
                        key={item.id+index}
                        data={item}
                        favoriteIconRef={favoriteIconRef}
                        withSlider={true}
                    />
                ))
            )}
        </div>
    );
};

export default BestOffersComponent;
